"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.groupBy = void 0;
function groupBy(list, key) {
    const dictionary = {};
    return list.reduce((current, next) => {
        (current[key(next)] = current[key(next)] || []).push(next);
        return current;
    }, dictionary);
}
exports.groupBy = groupBy;
